const $$splitComponentImporter = () => import('/app/src/routes/dashboard/therapist/settings.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { GoogleCalendarBlock } from "@/components/therapist/google-calendar-block";
// Not from the barrel: validateSearch stays in the entry chunk, and the barrel
// would drag every settings section along with it.
import { SECTIONS } from "@/components/therapist/settings/types";
export const Route = createFileRoute("/dashboard/therapist/settings")({
  validateSearch: (search: Record<string, unknown>): {
    section?: SettingsSection;
  } => {
    const section = search.section;
    return typeof section === "string" && SECTIONS.some(s => s.key === section) ? {
      section: section as SettingsSection
    } : {};
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});